import script from "./TagsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagsList.vue?vue&type=script&lang=ts&setup=true"

import "./TagsList.vue?vue&type=style&index=0&id=562bb436&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562bb436"]])

export default __exports__